module.exports = __webpack_public_path__ + "img/icon_8.abf44437.png";